/**
 * Utility functions for generating and working with user slugs
 * Slugs are URL-friendly versions of user names used in profile URLs
 */

/**
 * Generate a slug from a user's name
 * - Converts to lowercase
 * - Replaces spaces with hyphens
 * - Removes special characters
 * - Collapses multiple hyphens
 * 
 * @param name - User's name
 * @returns URL-friendly slug
 */
export function generateUserSlug(name: string | null | undefined): string | null {
  if (!name || name.trim() === '') {
    return null
  }

  return name
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '') // Remove special characters
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/-+/g, '-') // Collapse multiple hyphens
    .replace(/^-+|-+$/g, '') // Remove leading/trailing hyphens
}

/**
 * Get the profile URL for a user using their slug
 * Falls back to auth_id if slug is not available
 * 
 * @param slug - User's slug
 * @param authId - User's auth_id (fallback)
 * @returns Profile URL
 */
export function getUserProfileUrl(slug: string | null | undefined, authId?: string): string {
  if (slug) {
    return `/user/${slug}`
  }
  
  // Fallback to auth_id if slug not available
  if (authId) {
    return `/user/${authId}`
  }
  
  return '/dashboard'
}





